import mitt from 'mitt'

export type ApplicationEvents = {
  logoutRequired: { reason?: string }
}

const emitter = mitt<ApplicationEvents>()

export default emitter
